import './lib/sentry'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

// Recarrega no máximo 1x por janela curta para recuperar de erros transitórios
// SEM entrar em loop de reload quando o erro é permanente (o guard anti-loop
// faltava — um erro persistente recarregaria pra sempre).
function reloadOnceGuarded(reason: string) {
  try {
    const KEY = 'reload-guard-ts';
    const last = Number(sessionStorage.getItem(KEY) || '0');
    if (Date.now() - last < 15000) return; // recarregou há <15s → não reentra em loop
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch { /* sessionStorage indisponível → segue e recarrega mesmo assim */ }
  console.warn('[recover] reloading após:', reason);
  window.location.reload();
}

// Erros recuperáveis com um reload:
// - extensão de browser removendo nó React (removeChild)
// - asset "stale" após deploy: o browser com index.html/bfcache antigo pede um
//   chunk de hash velho; o servidor devolve HTML (SPA fallback) → o <script>
//   parseia HTML e dá "Unexpected token '<'" (era o buraco: só cobríamos
//   "Unable to preload CSS" e "Failed to fetch", nunca o SyntaxError síncrono).
function isRecoverableLoadError(msg: string): boolean {
  return (
    (msg.includes('removeChild') && msg.includes('not a child')) ||
    msg.includes('Unable to preload CSS') ||
    msg.includes('Failed to fetch dynamically imported module') ||
    msg.includes('Importing a module script failed') ||
    msg.includes("Unexpected token '<'") ||
    msg.includes('Unexpected token <')
  );
}

window.addEventListener('error', (event) => {
  const msg = event.message || '';
  if (isRecoverableLoadError(msg)) {
    event.preventDefault();
    reloadOnceGuarded(msg.slice(0, 80));
  }
});

window.addEventListener('unhandledrejection', (event) => {
  const msg = event.reason?.message || '';
  if (isRecoverableLoadError(msg)) {
    event.preventDefault();
    reloadOnceGuarded(msg.slice(0, 80));
  }
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
